<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <img src="/images/manutencao.jpg" style="width: 100%" alt="Manutenção">
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>